export default __webpack_public_path__ + "static/uea-logo-e0095968e7b4eba04de57e3760ceb7f6.png";